<template>
  <label
    class="check"
    :class="{
      'check--disabled': disabled,
      'check--error': error,
      'check--checked': checked,
      'check--indeterminate': indeterminate,
    }"
  >
    <span class="check__state"> </span>
    <input
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
      :indeterminate="indeterminate"
      @change="$emit('change', $event.target.checked)"
    />
    <slot />
  </label>
</template>

<script>
export default {
  name: "CheckboxComponent",
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    error: Boolean,
    checked: Boolean,
    disabled: Boolean,
    indeterminate: Boolean,
  },
};
</script>

<style lang="stylus">
.check {
  display flex
  gap 10px
  position relative
  cursor pointer
  align-items: flex-start;
  text-align: left;
  user-select none
  transition var(--transition)

  &:hover {
    color var(--main-color-75)
  }

  input {
    absolute left top
    visibility hidden
  }

  &--error {
    color var(--red) !important

    & .check__state {
      border-color var(--red) !important
    }
  }

  &--disabled {
    color var(--gray)

    & .check__state {
      background: var(--gray);
      border: 1px solid var(--gray);
    }

    &.check--indeterminate
    &.check--checked {
      & .check__state {
        background: var(--gray);
        border: 1px solid var(--gray);
      }

      svg path {
        fill var(--white)
      }
    }
  }

  &--indeterminate:not(&.check--disabled)
  &--checked:not(&.check--disabled) {
    & .check__state:after {
      opacity 1
    }
  }

  &--indeterminate:not(&.check--disabled) {
    & .check__state:after {
      height: 2px
    }
  }

  &__state {
    width 18px
    height 18px
    background: var(--white);
    border: 1px solid var(--main-color-75);
    box-sizing: border-box;
    border-radius: 4px;
    display flex
    align-items center
    justify-content center
    flex-shrink 0
    margin-top 2px
    transition var(--transition)

    &:after {
      content ""
      display block
      width 10px
      height: 10px
      border-radius 2px
      background: var(--main-color-75)
      opacity 0
      transition var(--transition)
    }
  }
}
</style>
